import { Injectable } from '@angular/core';
import { SignalROptions } from 'src/app/models/signalr';
const signalR = require('@microsoft/signalr');


@Injectable({
    providedIn: 'root'
})
export class SignalRService {


    initialize(options: SignalROptions) {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(`/${options.relativeUrl}`)
            .build();

        return connection;
    }

    // start(connection: any)  {

    // }



    // connection.on("send", data => {
    //     console.log(data);
    // });

    // connection.start()
    //     .then(() => connection.invoke("send", "Hello"));
    // }
}
